import { TOrderInfoKeyword } from "@/entities/new-order";

export function getCountriesOfKeywords(
  keywords: TOrderInfoKeyword[],
): string[] {
  const Countries: string[] = [];
  for (const keyword of keywords) {
    Countries.push(keyword.country);
  }
  return Array.from(new Set(Countries));
}
